// extracted by mini-css-extract-plugin
export default {"empty":"ResultsNotSelected_empty__Xpm1L","emptyDescription":"ResultsNotSelected_emptyDescription__rhkhI"};